import mediumZoom from "medium-zoom"
import React, { useLayoutEffect } from "react"
import SectionClient from "./section-client/section-client.component"
import SectionFornecedor from "./section-fornecedor/section-fornecedor.component"
import SectionSignature from "./section-signature/section-signature.component"
import SectionRegister from "./section-register/section-register.component"

export default function LandingSection() {
  useLayoutEffect(() => {
    mediumZoom("[data-zoomable]", {
      background: "rgba(25, 18, 25, 0.9)",
      margin: 24,
    })
  }, [])

  return (
    <>
      <SectionClient />
      <SectionFornecedor />
      <SectionSignature />
      <SectionRegister />
    </>
  )
}
